import {useRequest} from '@aboutyou/data-fetcher';
import {
  BASCampaignHeaderLogoTypes,
  useBasCampaign,
} from '../../features/AboutYouLogo/hooks/useBasCampaign';
import {useSessionGender} from '../../shared-deprecated/sessionGender';

export const useFixedHeader = () => {
  const basCampaign = useBasCampaign();
  const {gender} = useSessionGender();

  return useRequest<{basCampaign: BASCampaignHeaderLogoTypes | null}>(
    `FIXED_HEADER_KEY_${gender}`,
    async () => Promise.resolve({basCampaign}),
    {},
  );
};
